<div class="p-8">
  <div class="flex justify-between items-center">
    <h2 mat-dialog-title class="text-xl font-semibold">{{title}}</h2>
    <button class="text-gray-500 hover:text-gray-700" (click)="cancel()"> ✕ </button>
  </div>
  <div mat-dialog-content class="mt-4">
    <p>{{description}}</p>
  </div>

  <div mat-dialog-actions class="flex justify-end gap-3 mt-3">
    <button (click)="subscribe()"
      class="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">
      Subscribe
    </button>
  </div>
</div>